import React from 'react';
import { connect } from 'react-redux';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import {
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs
} from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import TabPanelDetail from '../atoms/TabPanelDetail';
import ImagePreview from './ImagePreview';

const styles = {
  root: {
    width: '100%'
  },
  detailTable: {
    width: '100%',
    padding: 15
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 200
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  userImage: {
    width: '100px',
    height: '100px'
  },
  tag: {
    margin: '0px 10px 0px 0px',
    backgroundColor: '#fee'
  },
  tabpanelHeader: {
    padding: '0 40px',
    borderBottom: '2px solid #D8EBFF',
    minHeight: 'unset'
  },
  btnTabpanel: {
    padding: '5px 10px',
    backgroundColor: '#F7F7F7',
    borderRadius: '3px 3px 0 0',
    fontSize: 14,
    fontWeight: 600,
    color: '#777777',
    height: 'auto',
    minHeight: 'unset',
    borderTop: '5px solid #ffffff',
    width: 165,

    '&:first-child': {
      marginRight: 2
    },
    '&:last-child': {
      marginLeft: 2
    }
  },
  tabSelected: {
    backgroundColor: '#D8EBFF',
    fontWeight: 'bold',
    color: '#000000 !important',
    borderTopColor: '#D8EBFF'
  },
  panelDetail: {
    padding: '15px 30px'
  },
  groupImage: {
    maxHeight: 80,
    maxWidth: 100,
    objectFit: 'contain'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      prefectures: state.commons.prefectures
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('tab', 'setTab', 0),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);
const Main = enhance(
  ({ classes, tab, setTab, detail, prefectures, isFukuoka }) => {
    const prefecture = prefectures.find(el => el.id === detail.prefectureCode);
    const handleChange = (event, newValue) => {
      setTab(newValue);
    };

    const groupDisplayLimit =
      detail.groupType === 'CAMPAIGN' ||
      detail.groupType === 'OTHERS' ||
      detail.groupType === 'GOCHI_KID';

    let depositManageStrFukuoka;
    if (isFukuoka) {
      if (detail.depositManageStr === 'グループでは入金管理を登録しない') {
        depositManageStrFukuoka = 'グループ口座を登録しない';
      } else if (detail.depositManageStr === '銀行口座を登録する') {
        depositManageStrFukuoka = 'グループ口座を登録する';
      }
    }

    return (
      <div className={classes.root}>
        <Tabs
          value={tab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          className={classes.tabpanelHeader}
        >
          <Tab
            label="基本情報（必須）"
            className={classNames(
              classes.btnTabpanel,
              tab === 0 && classes.tabSelected
            )}
          />
          <Tab
            label="その他（任意）"
            className={classNames(
              classes.btnTabpanel,
              tab === 1 && classes.tabSelected
            )}
          />
          {!groupDisplayLimit && !isFukuoka && (
            <Tab
              label="高度な設定（任意）"
              className={classNames(
                classes.btnTabpanel,
                tab === 2 && classes.tabSelected
              )}
            />
          )}
        </Tabs>

        <TabPanelDetail value={tab} index={0}>
          <div className={classes.panelDetail}>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    運営会社
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.groupName}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    郵便番号
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.zipCode}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    都道府県
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {prefecture && prefecture.name}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    市区町村
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.city}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    町域・番地
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.address}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    建物名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.building}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '代表電話番号' : '電話番号'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.phone}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    ご担当者名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.groupContactName}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    所属部署
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.department}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '電話番号（直通等）' : '電話番号 (直通等)*'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.directPhone}
                  </TableCell>
                </TableRow>

                {!groupDisplayLimit && !isFukuoka && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        インボイス制度 適格事業者登録
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.registrationId ? '登録済み' : '未登録'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        適格事業者登録番号
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.registrationId}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                {!isFukuoka && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      グループ種別
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.groupTypeStr}
                    </TableCell>
                  </TableRow>
                )}

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メールアドレス
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.email}
                  </TableCell>
                </TableRow>

                {!groupDisplayLimit && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      {isFukuoka ? 'グループ口座登録' : '入金管理'}
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {isFukuoka
                        ? depositManageStrFukuoka
                        : detail.depositManageStr}
                    </TableCell>
                  </TableRow>
                )}
                {detail.depositManage === 'NONSELF' && !groupDisplayLimit && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        銀行名
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.bankName ||
                          (detail.bankAccount && detail.bankAccount.bankName)}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        支店名
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.bankBranchName ||
                          (detail.bankAccount &&
                            detail.bankAccount.bankBranchName)}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        口座種別
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.bankAccountTypeStr ||
                          (detail.bankAccount &&
                            detail.bankAccount.bankAccountTypeStr)}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        口座番号
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.bankAccountNumber ||
                          (detail.bankAccount &&
                            detail.bankAccount.bankAccountNumber)}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        口座名義
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.bankAccountHolder ||
                          (detail.bankAccount &&
                            detail.bankAccount.bankAccountHolder)}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                {detail.createdAt && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      登録日時
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.createdAt}
                    </TableCell>
                  </TableRow>
                )}
                {detail.updatedAt && !isFukuoka && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      更新日時
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.updatedAt}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </TabPanelDetail>

        <TabPanelDetail value={tab} index={1}>
          <div className={classes.panelDetail}>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>FAX</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.fax}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    担当者メールアドレス
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.groupContactEmail}
                  </TableCell>
                </TableRow>
                {!isFukuoka && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        画像
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        <ImagePreview previewImage={detail.previewImage1} />
                        <ImagePreview previewImage={detail.previewImage2} />
                        <ImagePreview previewImage={detail.previewImage3} />
                        <ImagePreview previewImage={detail.previewImage4} />
                        <ImagePreview previewImage={detail.previewImage5} />
                        {detail.groupImages &&
                          detail.groupImages.map(img => (
                            <ImagePreview previewImage={img.image} />
                          ))}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        グループの概要
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.description}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        WebページURL
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.website}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    グループ紐付け時のメッセージ
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.linkingShopMessage}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </TabPanelDetail>

        {!groupDisplayLimit && (
          <TabPanelDetail value={tab} index={2}>
            <div className={classes.panelDetail}>
              <Table className={classes.detailTable}>
                {/* <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    社食ごちめし現金授受の有無
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.groupDetail && detail.groupDetail.cashAllowed
                      ? '受け付ける'
                      : '受け付けない'}
                  </TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    社食ごちめし金額指定チケット利用の有無
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.groupDetail &&
                    detail.groupDetail.allowMenuPriceShashoku
                      ? '利用する'
                      : '利用しない'}
                  </TableCell>
                </TableRow>
              </Table>
            </div>
          </TabPanelDetail>
        )}
      </div>
    );
  }
);
export default withRouter(withStyles(styles)(Main));
